import Difficulties from "./Difficulties";
import AssetManager from "./AssetManager";

export default class Globals {

    public static libAssetManager: AssetManager;
    public static gameAssetManager: AssetManager;
    public static difficulties: Difficulties;
    public static loadQueue: createjs.LoadQueue;

    public static gameId: string;

}



// WEBPACK FOOTER //
// ../lib/src/Globals.ts